import type { Event } from "@/utils/api/publicEventsApi";
import { resolveEventCategory } from "@/utils/events/eventCategory";

/**
 * Public events and guide listings: wild food, fall color, wildflowers, and photography.
 * Host dashboard / compliance still uses the full category list.
 * Species catalog membership lives in `speciesForagePrimary` (map and site share it).
 */
export const PUBLIC_SITE_EVENT_CATEGORY = "foraging";

/**
 * Researched third-party guide directory (Sanity `directoryHost`). Off on web:
 * listings drew almost no traffic and sent visitors off-site. The data stays in
 * Sanity for host outreach, and `/api/guides/*` keeps serving shipped mobile builds.
 * Re-enable together with the `/guides/:slug` redirect in vercel.json and the
 * sitemap flag in api/sitemap.js.
 */
export const GUIDE_DIRECTORY_PUBLIC = false;

export const PUBLIC_SITE_GUIDE_CATEGORIES = [
  "foraging",
  "leaf_peeping",
  "wildflower",
  "photography",
] as const;

const PUBLIC_SITE_EVENT_CATEGORIES = new Set<string>(PUBLIC_SITE_GUIDE_CATEGORIES);

export function isPublicSiteEventCategory(
  value: string | null | undefined,
): boolean {
  return PUBLIC_SITE_EVENT_CATEGORIES.has(
    String(value || "")
      .trim()
      .toLowerCase(),
  );
}

export function isPublicSiteEvent(
  event: Pick<Event, "category" | "tags">,
): boolean {
  return isPublicSiteEventCategory(resolveEventCategory(event));
}

export function isPublicSiteGuide(entry: {
  category?: string | null;
}): boolean {
  return isPublicSiteEventCategory(entry.category);
}
